import React from 'react'
import styles from './PlanCard.module.css'

const PlanCard = ({
  planName = 'Current Plan',   // static UI label (not data)
  planTagline = '',            // DATA — always from the parent; no fake fallback
  feeLabel = 'Monthly Plan Fee', // static UI label (not data)
  fee = '',                    // DATA — always from the parent; no fake fallback
  showFee = true,              // show the fee block (label + value). Off while loading AND when ended.
  seePlanInTop = false,        // ENDED state only: put "See Plan" top-right where the fee was.
  note = '',                   // DATA — always from the parent; no fake fallback
  taglineColor = '',           // per-plan brand colour for the subtitle (Scaler orange / Growth blue). Empty → default green.
  iconBg = '',                 // per-plan light circle background behind the icon. Empty → default green.
  icon = '',                   // per-plan icon (Growth/Scaler/PAYG). Empty while loading → no default flash.
  loading = false,             // true while data is still loading → show shimmer placeholders
  onSeePlan,
}) => {
  // Loading state → grey shimmer skeleton so the card doesn't show an empty
  // "Current Plan" with blank name/fee while the data is still coming.
  if (loading) {
    return (
      <div className={styles.card}>
        <div className={styles.top}>
          <div className={styles.left}>
            <div className={styles.iconWrap}>
              <span className={`${styles.skel} ${styles.skelIcon}`} />
            </div>
            <div>
              <span className={`${styles.skel} ${styles.skelName}`} />
              <span className={`${styles.skel} ${styles.skelSub}`} />
            </div>
          </div>
          <div className={styles.right}>
            <span className={`${styles.skel} ${styles.skelFeeLabel}`} />
            <span className={`${styles.skel} ${styles.skelFee}`} />
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={styles.card}>
      <div className={styles.top}>
        <div className={styles.left}>
          <div className={styles.iconWrap} style={iconBg ? { background: iconBg } : undefined}>
            {/* Per-plan icon from the parent. Only rendered once it's known, so
                a default icon doesn't flash and then change to the real plan's
                icon while loading. */}
            {icon ? <img src={icon} alt="Plan Icon" /> : null}
          </div>
          <div>
            <p className={styles.planName}>{planName}</p>
            <p className={styles.planTagline} style={taglineColor ? { color: taglineColor } : undefined}>{planTagline}</p>
          </div>
        </div>
        {showFee && (
          <div className={styles.right}>
            <p className={styles.feeLabel}>{feeLabel}</p>
            <p className={styles.fee}>{fee}</p>
          </div>
        )}
        {/* ENDED plan only: no fee, so "See Plan" sits top-right (where the fee
            was) to keep the card balanced. While LOADING, neither shows — the
            top-right stays empty so the skeleton doesn't look like the ended
            state (which confused the reactivation reload). */}
        {!showFee && seePlanInTop && (
          <button type="button" className={styles.seePlanTop} onClick={onSeePlan}>
            See Plan →
          </button>
        )}
      </div>

      {/* Bottom row (note + See Plan) only when the fee is shown. When there's
          no fee, See Plan already moved to the top-right, so skip this row. */}
      {showFee && (
        <div className={styles.bottom}>
          {note ? (
            <span className={styles.note}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_5893_512)">
                  <path d="M11 5.54091V6.00091C10.9994 7.07912 10.6503 8.12825 10.0047 8.99182C9.35908 9.85539 8.45164 10.4871 7.41768 10.7929C6.38372 11.0986 5.27863 11.0619 4.26724 10.6882C3.25584 10.3145 2.39233 9.62396 1.80548 8.71944C1.21863 7.81492 0.939896 6.74494 1.01084 5.66907C1.08178 4.59319 1.4986 3.56907 2.19914 2.74944C2.89968 1.92982 3.84639 1.3586 4.89809 1.12098C5.9498 0.883364 7.05013 0.992077 8.035 1.43091M11 2.00091L6 7.00591L4.5 5.50591" stroke="#00AD6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_5893_512">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              {note}
            </span>
          ) : (
            <span />
          )}
          <button type="button" className={styles.seePlan} onClick={onSeePlan}>
            See Plan →
          </button>
        </div>
      )}
    </div>
  )
}

export default PlanCard
